<template>
    <div>
        <a-card title="性能分析" >
            <div style="margin-bottom:18px;">
                <div>
                    <envSelecter v-model="selectedEnv" style="display:inline-flex;"></envSelecter>
                    <sysSelecter v-model="sleectedSys" style="display:inline-flex;"></sysSelecter>
                    <timeSelecter v-model="selectedTimeRange" style="margin-left:20px;"></timeSelecter>
                    <a-button type="primary" style="margin-left:20px;" @click="handleSubmit">查询</a-button>
                </div>
            </div>

            <a-row :gutter="[16,16]">
                <a-col :span='12'>
                   <top20List :chartType="'apitopID'" ref="topApiListID"></top20List>
                </a-col>
                <a-col :span='12'>
                   <top20List :chartType="'resourcetopID'" ref="topResourceListID"></top20List>
                </a-col>
            </a-row>


            <a-row :gutter="[16,16]">
                <a-col :span='24'>
                   <firstpageloadtime ref="firstpageloadtimeID"  :style="{width:tableWidth}"></firstpageloadtime>
                </a-col>
            </a-row>
        </a-card>

    </div>
</template>

<script>
import sysSelecter from '../components/sysSelecter'
import envSelecter from '../components/envSelecter'
import timeSelecter from '../components/timeselecter'
import top20List from './top20List'
import firstpageloadtime from './firstpageloadtime'

export default {
    data(){
        return {
            sleectedSys:'',
            selectedEnv:'',
            selectedTimeRange:'',
            tableWidth:'800px',
        }
    },
    methods:{
        handleSubmit(){
            this.$refs.topApiListID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange,1);
            this.$refs.topResourceListID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange,1);


            this.$refs.firstpageloadtimeID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        }
    },
    mounted(){
        this.getTableWidth();
        this.handleSubmit();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);
    },
    components:{
        timeSelecter,
        sysSelecter,
        envSelecter,
        firstpageloadtime,
        top20List
    }
};
</script>

<style lang="less" scoped>
</style>
<style>

</style>